import React, { useState, useEffect, useRef } from 'react';
import icon1 from "../../assets/icon-interior.svg";
import icon2 from "../../assets/icon-exterior.svg";
import icon3 from "../../assets/icon-pressure-washing.svg";
import "./services.css";

const Services = () => {
    const [isVisible, setIsVisible] = useState(false);
    const servicesRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(servicesRef.current);
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1, // Cambia el valor según sea necesario
            }
        );

        if (servicesRef.current) {
            observer.observe(servicesRef.current);
        }

        return () => {
            if (servicesRef.current) {
                observer.unobserve(servicesRef.current);
            }
        };
    }, []);

    return (
        <section className="services section" id="services" ref={servicesRef}>
            <h2 className="section__title">
                <i className="uil uil-briefcase-alt services__title__icon"></i>
                Services
            </h2>
            <span className="section__subtitle">What We Offer</span>

            <div className="services__container container grid">
                {/*SERVICE 1*/}
                <div className={`services__content ${isVisible ? 'animate' : ''}`}>
                    <div className='services__div'>
                        <div className='services__div__icon'>
                            <object className='icon__interior' data={icon1} />
                        </div>
                        <div className='services__div__title'>
                            <h3 className="services__title">
                                Interior
                            </h3>
                        </div>
                        <div className='services__div__list'>
                            <ul className='services__list'>
                                <li>Wall</li>
                                <li>Cabinet</li>
                                <li>Wallpaper removal</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/*SERVICE 2*/}
                <div className={`services__content ${isVisible ? 'animate' : ''}`}>
                    <div className='services__div'>
                        <div className='services__div__icon'>
                            <object className='icon__exterior' data={icon2} />
                        </div>
                        <div className='services__div__title'>
                            <h3 className="services__title">
                                Exterior
                            </h3>
                        </div>
                        <div className='services__div__list'>
                            <ul className='services__list'>
                                <li>House</li>
                                <li>Building</li>
                                <li>Fences</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/*SERVICE 3*/}
                <div className={`services__content ${isVisible ? 'animate' : ''}`}>
                    <div className='services__div'>
                        <div className='services__div__icon'>
                            <object className='icon__pressure__washing' data={icon3} />
                        </div>
                        <div className='services__div__title'>
                            <h3 className="services__title">
                                Pressure washing
                            </h3>
                        </div>
                        <div className='services__div__list'>
                            <ul className='services__list'>
                                <li>House</li>
                                <li>Roof</li>
                                <li>Concrete</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Services;
